import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { PublicKey } from '@solana/web3.js';
import { getConnection } from '../config/sol';
import useTomoUserInfo from './useTomoUserInfo';

export const useSolBalance = () => {
  const { solAddress } = useTomoUserInfo();
  return useQuery({
    queryKey: ['SolBalance', solAddress],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    retry: 5,
    queryFn: async () => {
      try {
        if (solAddress) {
          const connection = getConnection();
          const publicKey = new PublicKey(solAddress);
          const balance = await connection.getBalance(publicKey);
          if (balance) {
            return BigInt(balance);
          }
        }
      } catch (error) {
        console.warn(error);
      }
      return null;
    },
  });
};
